<template>
  <div>
    <VDivider class="my-4" />
    <div class="d-flex flex-wrap mb-5">
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box success"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.empty") }}
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box warning"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.hasSpace") }}
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box error"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.full") }}
          </div>
        </div>
      </div>
    </div>
    <div class="warehouse-reference-wrapper">
      <div class="d-flex flex-column align-center justify-space-between">
        <div
          ref="wrapper"
          :style="{
            overflow: 'auto',
            maxHeight: $vuetify.breakpoint.height - 380 + 'px',
            maxWidth: '100%',
            width: '100%',
          }"
        >
          <!-- +=+=+=+=++=+=+=+=+ |column numeration| +=+=+=+=++=+=+=+=+ -->
          <div
            class="warehouse-view-table-navigation warehouse-view-table-navigation-horizontal"
          >
            <WarehouseBox
              :key="`letter-${letterIndex}`"
              class="text-uppercase"
              :width="columnWidth"
              :class="['warehouse-index-top-box']"
              v-for="(columnWidth, letterIndex) in data.columns"
              >{{ getLetter(letterIndex) }}
            </WarehouseBox>
          </div>
          <!--column numeration-->

          <div class="d-flex">
            <!-- +=+=+=+=++=+=+=+=+ |row numeration| +=+=+=+=++=+=+=+=+ -->
            <div
              class="warehouse-view-table-navigation warehouse-view-table-navigation-vertical"
            >
              <WarehouseBox
                :height="rowHeight"
                :key="`row-${rowIndex}`"
                :class="['warehouse-index-left-box']"
                v-for="(rowHeight, rowIndex) in data.rows"
                >{{ rowIndex + 1 }}
              </WarehouseBox>
            </div>
            <!--row numeration-->
            <div class="d-flex text-uppercase table-cell-wrapper">
              <!-- +=+=+=+=++=+=+=+=+ |columns start| +=+=+=+=++=+=+=+=+ -->
              <!--                                  @click="
                    boxClickHandler(row, getLetter(columnIndex), rowIndex + 1)
                  "-->
              <div
                v-for="(column, columnIndex) in data.boards"
                :key="columnIndex"
              >
                <WarehouseStillageBox
                  :width="row.width"
                  :height="row.height"
                  @contextmenu.prevent="boxContextMenuHandler(row)"
                  :key="`row-${rowIndex}-${columnIndex}`"
                  v-for="(row, rowIndex) in column"
                  :item="row"
                  :class="[
                    selectedCellId === row.id ? 'show_animation_alarm' : '',
                  ]"
                >
                  {{ getLetter(columnIndex) }}{{ rowIndex + 1 }}
                </WarehouseStillageBox>
              </div>
              <!-- columns end-->
            </div>
          </div>
        </div>
        <VBtn
          color="primary"
          class="float-right mt-4"
          @click="$refs.confirmPlacementDialogRef.open()"
          :disabled="selectedCellId === null"
          style="position: absolute; bottom: 35px"
          >{{ $t("placeHere") }}</VBtn
        >
      </div>
    </div>
    <ShowCellProductsDialog
      ref="showCellProductsDialogRef"
      :warehouse="warehouse"
      :cellInfo="cellInfo"
      @placeHere="placeHere"
    ></ShowCellProductsDialog>
    <WarningDialog
      @apply="placeHere(selectedCellId)"
      title=""
      description="confirmPlacement"
      yesText="putProduct"
      :max-width="440"
      noText="toCancel"
      ref="confirmPlacementDialogRef"
      v-model="confirmPlacementDialog"
    />
    <RemainPlaceDialog
      ref="remainPlaceDialogRef"
      :boxDetails="boxDetails"
      @clearProductItemIds="$emit('clearProductItemIds')"
    ></RemainPlaceDialog>
    <NotificationSystem ref="notificationError" />
  </div>
</template>

<script>
import { getLetter } from "@/utils/numeration";
import "@/components/warehouse/warehouse.css";
import "@/components/warehouse/warehouse-edit-table.css";
import { trueSet } from "@/utils/pureFunctions";
import WarehouseStillageBox from "@/components/warehouse/StillageBox";
import WarehouseBox from "@/components/warehouse/WarehouseBox.vue";
import ShowCellProductsDialog from "@/components/omtk/ShowCellProductsDialog.vue";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";
import RemainPlaceDialog from "@/components/omtk/RemainPlaceDialog.vue";
import NotificationSystem from "@/components/notificationSystem.vue";

export default {
  name: "omtk-stillage-view",
  data() {
    return {
      selectedCellId: null,
      carriageId: null,
      cellInfo: {},
      boxDetails: [],
      confirmPlacementDialog: null,
    };
  },
  components: {
    NotificationSystem,
    WarehouseBox,
    WarehouseStillageBox,
    ShowCellProductsDialog,
    WarningDialog,
    RemainPlaceDialog,
  },
  props: {
    data: { type: Object },
    warehouse: { type: Object },
    productItemIds: {
      type: Array,
      required: true,
    },
    toWarehouseId: { type: String },
    fromWarehouseId: {
      type: String,
    },
    selectedProductId: {
      type: String,
    },
  },
  methods: {
    boxClickHandler(item, columnIndex, rowIndex) {
      this.cellInfo = item;
      if (item.hasProduct) {
        const { showCellProductsDialogRef } = this.$refs;
        if (showCellProductsDialogRef) {
          showCellProductsDialogRef.open(columnIndex, rowIndex, item.id);
        }
      }
    },
    boxContextMenuHandler(item) {
      if (!item.full) {
        this.selectedCellId = item.id;
      }
    },
    clearSelectedCells() {
      this.selectedCellId = null;
    },
    async placeHere(carriageId) {
      try {
        this.showLoading();
        let params = {
          productId: this.selectedProductId,
          carriageId: carriageId,
          productItemIds: this.productItemIds,
          newWarehouseId: this.toWarehouseId,
          oldWarehouseId: this.fromWarehouseId,
        };
        await this.$http.post("product-item/move-product", params);

        await this.getCellDetails([carriageId]);

        const { remainPlaceDialogRef } = this.$refs;
        if (remainPlaceDialogRef) {
          remainPlaceDialogRef.open();
        }

        this.$emit("place-here");
      } catch (e) {
        // this.setResponseError({ error: e });
        this.$refs.notificationError.open({
          title: e.response.data.error_message.title,
        });
      } finally {
        this.clearLoading();
      }
    },
    async getCellDetails(carriageIds) {
      try {
        this.showLoading();
        const {
          data: { data },
        } = await this.$http.get(
          `carriage/for-marking-full?${Object.values(carriageIds)
            .map((id) => `ids=${id}`)
            .join("&")}`
        );
        this.boxDetails = data.map((item) => {
          item.done = false;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    getLetter: () => getLetter,
    trueSet: () => trueSet,
  },
};
</script>

<style scoped lang="scss">
.show_animation_alarm {
  &::before {
    content: "";
    width: 13px;
    position: absolute;
    height: 13px;
    border-radius: 50%;
    background: red;
    opacity: 0.8;
    right: 5px;
    top: 5px;
    animation: pulse 2s linear infinite;
  }
}
</style>
